import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, map, catchError, finalize } from 'rxjs/operators';
import { CaseTypeRepository } from '../../../infrastructure/repositories/case-type.repository';
import { CaseTypeState } from '../../states/case-type.state';
import { CreateCaseTypeResult } from './create-case-type.result';
import { CreateCaseTypeCommand } from './create-case-type.command';

@Injectable({ providedIn: 'root' })
export class CreateCaseTypeUseCase {
  private readonly repository = inject(CaseTypeRepository);
  private readonly state = inject(CaseTypeState);

  public execute(params: CreateCaseTypeCommand): Observable<CreateCaseTypeResult> {
    this.state.setSaving(true);
    this.state.clearError();

    return this.repository.createCaseType(params).pipe(
      switchMap((result) =>
        this.repository.getAllCaseTypes().pipe(
          map((caseTypes) => {
            this.state.setCaseTypes(caseTypes);
            return { id: result.id };
          })
        )
      ),
      catchError((error) => {
        throw error;
      }),
      finalize(() => this.state.setSaving(false))
    );
  }
}
